var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7246 34C26.2006 34 25.6786 33.796 25.2866 33.39L17.5606 25.39C16.8046 24.604 16.8146 23.358 17.5866 22.586L25.5866 14.586C26.3666 13.804 27.6326 13.804 28.4146 14.586C29.1946 15.368 29.1946 16.632 28.4146 17.414L21.8046 24.024L28.1626 30.61C28.9306 31.406 28.9086 32.672 28.1146 33.438C27.7246 33.814 27.2246 34 26.7246 34Z",
    fill: "#181464"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_92_5166",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 13,
    width: 12,
    height: 21
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7246 34C26.2006 34 25.6786 33.796 25.2866 33.39L17.5606 25.39C16.8046 24.604 16.8146 23.358 17.5866 22.586L25.5866 14.586C26.3666 13.804 27.6326 13.804 28.4146 14.586C29.1946 15.368 29.1946 16.632 28.4146 17.414L21.8046 24.024L28.1626 30.61C28.9306 31.406 28.9086 32.672 28.1146 33.438C27.7246 33.814 27.2246 34 26.7246 34Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_92_5166)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#181464"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.dcc286f6b4b4c25a543122d04409f365.svg";
export { ForwardRef as ReactComponent };